import React, { Fragment } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import Icon from 'dpl/common/components/Icon';
import { isLessThanBreakpoint } from 'dpl/util/grid';
import { ABOUT_US_PATH } from 'dpl/shared/constants/urls';

import { VALUE_BANNER_ITEMS } from '../utils/constants';

const IS_LT_MD = isLessThanBreakpoint('md');
const ICON_SIZE = IS_LT_MD ? '24px' : '32px';

function Divider() {
  return (
    <div
      className={classnames('SLPValueBanner__divider b--default o-40', {
        'mv5 bb': IS_LT_MD,
        'mv7 mh6 br': !IS_LT_MD
      })}
    />
  );
}

function BannerItem({ items: { icon, text } }) {
  return (
    <div className="BannerItem tc flex flex-column items-center">
      <Icon
        name={icon}
        width={ICON_SIZE}
        height={ICON_SIZE}
        className="white mb4"
      />
      <p className="font-serif font-24 md:font-32 fw-medium white">{text}</p>
    </div>
  );
}

BannerItem.propTypes = {
  items: PropTypes.shape({
    icon: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired
  }).isRequired
};

export default function ValueBanner() {
  return (
    <div className="ValueBanner bg-stone-700 pt10 pb10 pb12-md flex flex-column">
      <div className="container-xxl flex mb5 mb8-md flex-column flex-md-row justify-content-md-center">
        {VALUE_BANNER_ITEMS.map((item, idx) => {
          return (
            <Fragment key={idx}>
              <BannerItem items={item} />
              {idx !== VALUE_BANNER_ITEMS.length - 1 && <Divider />}
            </Fragment>
          );
        })}
      </div>
      <a
        href={ABOUT_US_PATH}
        target="_blank"
        rel="noopener noreferrer"
        className="white underline tc font-14 md:font-18 fw-medium fw-normal-ns"
      >
        Learn more about Good Dog
      </a>
    </div>
  );
}
